export const getInitialValues = (eventType) => ({
  lockTimezoneStatus: eventType.lock_timezone_enabled ? 'locked' : 'local',
  lockTimezoneContent: eventType.lock_timezone_content || eventType.timezone,
})
